import { useParams } from 'react-router-dom'
import { useProjectById } from '../api/getProjectById'
import { useCurrentProject } from '../store/currentProject'
import { useEffect } from 'react'

export const ViewProject = () => {
  const { projectId } = useParams() as { projectId: string }
  const project = useProjectById(projectId)
  const currentProject = useCurrentProject()
  useEffect(() => {
    currentProject.setCurrentProject(project.data)
    return () => currentProject.setCurrentProject(undefined)
  }, [project.data])
  if (project.isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
      </div>
    )
  }

  if (!project.data) return null
  return (
    <div className="flex w-full flex-col gap-y-[12px] lg:flex-row">
      <div className="flex w-full flex-col gap-y-[12px] lg:w-1/2">
        {project.data.images.map(
          ({ url, id }, index) =>
            index % 2 === 0 && <ProjectCard key={id} url={url} index={index} />
        )}
      </div>
      <div className="flex w-full flex-col gap-y-[12px] lg:w-1/2">
        {project.data.images.map(
          ({ url, id }, index) =>
            index % 2 !== 0 && <ProjectCard key={id} url={url} index={index} />
        )}
      </div>
    </div>
  )
}

const ProjectCard = ({ index, url }: { url: string; index: number }) => {
  return (
    <div
      className={`group overflow-hidden ${index % 2 === 0 ? 'lg:mr-[23px]' : ''}`}
    >
      <img
        src={url}
        className="w-full transition-all  duration-300 lg:group-hover:scale-125"
      />
    </div>
  )
}
